import React, { useEffect } from 'react';
import { useTag } from '../../DataStore/TagContext';
import { useVendor } from '../../DataStore/VendorContext';
import { useIncomingInvoice } from '../../DataStore/IncomingInvoiceContext';

// Reusable component for each counter card
const CounterCard = ({ value, textColor, heading, subheading }) => {
    return (
        <div className="col-md-6 col-xl-4">
            <div className="widget-content">
                <div className="widget-content-wrapper">
                    <div className="widget-content-right ml-0 mr-3">
                        <div className={`widget-numbers ${textColor}`}>{value}</div>
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{heading}</div>
                        <div className="widget-subheading">{subheading}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const CounterStrip = () => {
    const {getTagCount, tagCount} = useTag();
    const {getVendorCount, VendorCount} = useVendor();
    const {getUnpaidInvoiceCount, unpaidInvoiceCount} = useIncomingInvoice();
    useEffect(()=>{
        getTagCount();
        getVendorCount();
        getUnpaidInvoiceCount();
    }, [])

   
    return (
        <div className="main-card mb-3 card">
            <div className="no-gutters row">
                    <CounterCard 
                        value={VendorCount} 
                        textColor="text-success" 
                        heading="Total Vendors" 
                        subheading="For all financial years" 
                    />
                    <CounterCard 
                        value={tagCount} 
                        textColor="text-warning" 
                        heading="Total Tags" 
                        subheading="For all financial years" 
                    />
                    <CounterCard 
                        value={unpaidInvoiceCount} 
                        textColor="text-danger" 
                        heading="Invoices Payable" 
                        subheading="Incoming invoices for this FY" 
                    />
                {/* Extra CounterCard for smaller screens */}
                {/* <div className="d-xl-none d-md-block col-md-6 col-xl-4">
                    <CounterCard
                        value="45.9%"
                        textColor="text-danger"
                        heading="Followers"
                        subheading="People Interested"
                    />
                </div> */}
            </div>
        </div>
    );
};

export default CounterStrip;
